namespace $.$$ {

	const Dragger = {
		position: 'absolute',
		top: 0,
		width: '32px',
		minWidth: '32px',
		height: '40px',
		padding: 0,
		justify: { content: 'center' },
		background: { color: $mol_theme.card },
		cursor: 'grab',
		touchAction: 'none',
		display: 'none',
		opacity: 0,
		pointerEvents: 'none',
		transition: 'none',
	} as const

	const Icon = { width: '1.5rem', margin: '-0.65rem' } as const

	$mol_style_define( $shm_hitalama_map_book_tools_float, {

		position: 'fixed',
		zIndex: $mol_layer.float,
		transition: 'none',
		width: 'fit-content',
		height: 'fit-content',

		Tools: {
			maxHeight: '100%',
			'[shm_hitalama_quick2_vertical]': {
				true: { overflowY: 'auto' },
			},
		},

		Dragger_left: { ...Dragger, left: '-32px' },
		Dragger_right: { ...Dragger, right: '-32px' },

		'[dragger_side]': {
			left: { Dragger_left: { display: 'flex', opacity: 1, pointerEvents: 'auto' } },
			right: { Dragger_right: { display: 'flex', opacity: 1, pointerEvents: 'auto' } },
		},

		Drag_left_icon_1: Icon,
		Drag_left_icon_2: Icon,
		Drag_right_icon_1: Icon,
		Drag_right_icon_2: Icon,

	} )

	$mol_style_define( $shm_hitalama_map_book_tools_float_quick, {
		Button: {
			'[mol_check_checked]': {
				true: { outlineOffset: '-2px' },
			},
		},
	} )

}
